import {
  OEText,
  ph,
  pv,
  ViewGradiantBackground,
} from '@openeducation/oe-it-components';
import { dateArrayToString } from '@openeducation/oe-it-services';
import type { LiveClassPendingFeedback } from '@openeducation/oe-it-shared-types';
import { styled } from '@openeducation/oe-it-themes';
import React, { memo } from 'react';
import { TouchableOpacity, View } from 'react-native';

import { TestId } from '../../constants/test-id';

const BORDER_HEIGHT = 1;

export interface PCPendingFeedbackListItemProps {
  feedback: LiveClassPendingFeedback;
  onSelectFeedback: (feedback: LiveClassPendingFeedback) => void;
  isSelected?: boolean;
}

const PCPendingFeedbackListItem = ({
  feedback,
  onSelectFeedback,
  isSelected,
}: PCPendingFeedbackListItemProps) => {
  const { studentName, studentLevel, dateOfClass } = feedback;

  const renderItemContent = () => {
    return (
      <View style={[ph(8), pv(10)]}>
        <Title
          isSelected={isSelected}
          fontSize={16}
          fontType="bold"
          numberOfLines={2}
        >
          {studentName}
        </Title>
        <OEText fontSize={16} numberOfLines={1}>
          {studentLevel && `Level ${studentLevel} `}
        </OEText>
        <TimeText>
          {dateArrayToString(dateOfClass, 'MMM, dd yyyy - h:mm a')}
        </TimeText>
      </View>
    );
  };

  const renderItem = () => {
    if (isSelected) {
      return (
        <ContainerGradient
          testID={TestId.PC_PENDING_FEEDBACK_LIST_ITEM_SELECTED}
        >
          <GradientLine />
          {renderItemContent()}
          <GradientLine />
        </ContainerGradient>
      );
    }

    return (
      <NonSelectedItem testID={TestId.PC_PENDING_FEEDBACK_LIST_ITEM}>
        {renderItemContent()}
      </NonSelectedItem>
    );
  };

  return (
    <TouchableOpacity onPress={() => onSelectFeedback(feedback)}>
      {renderItem()}
    </TouchableOpacity>
  );
};

type TitleType = {
  isSelected?: boolean;
};

const Title = styled(OEText)<TitleType>`
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.color.primary : theme.color.dark1};
  margin-bottom: 8px;
`;

const TimeText = styled(OEText)`
  color: ${({ theme }) => theme.color.dark2};
`;

const ContainerGradient = styled(ViewGradiantBackground).attrs(({ theme }) => ({
  colorX0: theme.color.primary,
  colorX1: theme.color.white,
  opacity: 0.2,
}))``;

const GradientLine = styled(ViewGradiantBackground).attrs(({ theme }) => ({
  colorX0: theme.color.primary,
  colorX1: theme.color.white,
}))`
  height: ${BORDER_HEIGHT}px;
`;

const NonSelectedItem = styled.View`
  margin-right: 24px;
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.color.border};
  border-top-color: ${({ theme }) => theme.color.border};
`;

export default memo(PCPendingFeedbackListItem);
